define('modules/lp_info/index',['require','exports','module','base/router','lib/util','common/views/dashboard_layout','./models/page','./collections/page_variants','./views/main','common/views/404','common/models/date_model','ThemesHelper'],function (require, exports, module) {
  'use strict';

  var Router = require('base/router'),
    util = require('lib/util'),
    DashboardLayout = require('common/views/dashboard_layout'),
    Page = require('./models/page'),
    PageVariants = require('./collections/page_variants'),
    MainController = require('./views/main'),
    View404 = require('common/views/404'),
    DateModel = require('common/models/date_model'),
    ThemesHelper = require('ThemesHelper');

  module.exports = function (moduleManager) {
    var ModuleRouter = Router.extend({
      platforms: ['desktop', 'mobile', 'amp'],

      routes: {
        'info/:id': 'infoLp',
        'info/:id/new/:mode': 'createVariant',
      },

      activatePagesTab: function (next) {
        $('.ed-navlink.active').removeClass('active');
        $('.js-pages').addClass('active');
      },

      clearBodyClasses: function () {
        $('body').attr('class', '');
      },

      beforeAll: function () {
        var page = new Page(),
          dashboard = moduleManager.showInstance(DashboardLayout, { hideTitle: true }),
          oldDateModel =
            dashboard.$top.currentView &&
            dashboard.$top.currentView.$datepicker &&
            dashboard.$top.currentView.$datepicker.currentView &&
            dashboard.$top.currentView.$datepicker.currentView.model,
          dateModel = this._cloneDate(oldDateModel),
          variants = new PageVariants([], {
            page: page,
            date: dateModel,
          }),
          mainController = new MainController({
            model: page,
            variants: variants,
          });

        //just in case we came from pages
        dashboard.$top.close();
        dashboard.$search.close();
        this.activatePagesTab();
        this.clearBodyClasses();
        ThemesHelper.addThemeClass(ThemesHelper.getCurrentTheme());
        return { mainController: mainController, dashboard: dashboard };
      },

      infoLp: function (id, views) {
        views.dashboard.$el.find('.ed-subnav').addClass('hidden');
        views.dashboard.showLoading();
        views.mainController.model.id = id;
        views.mainController.model.fetch({
          success: function () {
            views.dashboard.$content.show(views.mainController);
          },
          error: function () {
            views.dashboard.$el.find('.ed-subnav').removeClass('hidden');
            views.dashboard.$content.show(new View404());
          },
        });
      },

      createVariant: function (id, mode, views) {
        if (!_.contains(this.platforms, mode)) {
          return this.navigate('/info/' + id, { trigger: true, replace: true });
        }

        views.mainController.model.id = id;
        util.onModelReady(
          views.mainController.model,
          _.bind(views.mainController.createVariant, views.mainController, mode)
        );
      },

      _cloneDate: function (oldDate) {
        var date = new DateModel();
        oldDate = oldDate || date;
        date.set(_.clone(oldDate.attributes), { silent: true });
        return date;
      },
    });

    return new ModuleRouter();
  };
});

